var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.jobProfileData
    ? _c(
        "div",
        {
          staticClass: "job-listing--item-head-short-info",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.goToEditPage.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "profile-view" }, [
            _c("div", { staticClass: "tag-sections" }, [
              _c("section", [
                _c("div", { staticClass: "sub-sections" }, [
                  _c(
                    "div",
                    { staticClass: "sub-section" },
                    [
                      _vm.jobProfileData.salary
                        ? _c("Salary", {
                            staticClass: "inline",
                            attrs: {
                              data: _vm.jobProfileData.salary,
                              "with-collective": false
                            }
                          })
                        : _vm.jobProfileData.hourlyRate
                        ? _c("HourlyRate", {
                            staticClass: "inline",
                            attrs: {
                              data: _vm.jobProfileData.hourlyRate,
                              label: "Stundensatz"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.employmentMode
                        ? _c("div", { staticClass: "sub-values inline" }, [
                            _c("div", { staticClass: "sub-value" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("Beschäftigungsart")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("Label", {
                                    attrs: {
                                      characteristic: _vm.employmentMode,
                                      "label-type": _vm.labelTypeJobProfile,
                                      "max-item-length": 20
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }